<template>
  <div @mouseenter="showButton" @mouseleave="hideButton">
    <div :style="visibilityStyle" class="row">
      <div class="col-md-4">
        <button type="button" @click="toggleFullscreen" class="btn btn-raised btn-primary">
          <i class="fas fa-expand" /> Plein écran
        </button>
      </div>
      <div class="col-md-4">
        <button type="button" @click="parametersClick" class="btn btn-raised btn-primary">
          <i class="fas fa-cogs" /> Configuration
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightsButtons',
  data() {
    return {
      showButtons: false,
    };
  },
  computed: {
    visibilityStyle() {
      return { visibility: this.showButtons ? 'visible' : 'hidden' };
    },
  },
  methods: {
    parametersClick() {
      this.$store.commit('toggleConfig');
    },
    toggleFullscreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
    showButton() {
      this.showButtons = true;
    },
    hideButton() {
      this.showButtons = false;
    },
  },
};
</script>

<style scoped></style>
